// Interfaces
import { IBaseTitleProps } from './interfaces'

const BaseTitle = ({ title, ...rest }: IBaseTitleProps) => {
  return (
    <h4 {...rest} className={`text-dark-blue-color font-weight-700 font-20 ${rest.className ? rest.className : ''}`}>
      {title}
    </h4>
  )
}

export { BaseTitle }
